import { put } from 'redux-saga/effects';
import { UPLOAD_SERIES_SUCCESS } from '../actions/actionTypes';

export default function* sagaReload() {
  yield put({
    type: UPLOAD_SERIES_SUCCESS,
    payload: {},
  });
}
